import styled, { css } from 'styled-components';
import { getColor, StyleVars, typeScale } from 'core/utils';
import { hideScroll, ieTarget, resetBtn } from 'styled-manila';

export const Wrapper = styled.div`
	padding: 16px 0;
	position: relative;
	overflow: hidden;
	display: flex;
	${ieTarget`
		padding-right: 14px;
	`}

	@media(max-width: ${StyleVars.screenSm}) {
		padding: ${typeScale(1)} 0;
	}
`;

export const OverFlower = styled.div`
	${hideScroll}
	scrollbar-width: none;
	overflow-x: scroll;
	-webkit-overflow-scrolling: touch;
	margin: -4px;
	display: flex;
	height: 100%;
`;

const slideWidth = width => css`
	max-width: ${width}px;
	flex-basis: ${width}px;
	min-width: ${width}px;
`;

export const Slide = styled.div`
	${slideWidth(106)}
	padding: 0px 4px;

	@media(max-width: ${StyleVars.screenSm}) {
		${slideWidth(61)}
		padding: 3px 3px;
	}
`;

export const Frame = styled.div`
	overflow: hidden;
	position: relative;
	padding-top: ${props => props.ratio};
	background-color: ${getColor('alto')};
	border-radius: 8px;

	&:before {
		content: '';
		width: 100%;
		height: 100%;
		border: 3px solid transparent;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 2;
		transition: border 0.3s;
		border-radius: 8px;
	}

	${props => props.isCurrent && !props.soloItem && css`
		&:before {
			border-color: ${getColor('primaryBrand')};
		}
	`}

	img {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
`;

export const Trigger = styled.button`
	${resetBtn};
	display: block;
	width: 100%;
	position: relative;
`;

export const PlayWrapper = styled.div`
	position: absolute;
	z-index: 2;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	${({ clear } ) => !clear && css`
		background: rgba(255, 255, 255, 0.48);
	`}

	svg {
		width: 47px;
		height: 47px;

		@media(max-width: ${StyleVars.screenSm}) {
			width: 30px;
			height: 30px;
		}
	}
`;

